import { FrequencyType } from '@wix/ambassador-bookings-services-v2-service/types';
function getDatePartsInTimezone(date, timezone) {
  var _parts$find, _parts$find2, _parts$find3;
  if (!timezone) {
    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate()
    };
  }
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  }).formatToParts(date);
  const year = Number(((_parts$find = parts.find(p => p.type === 'year')) == null ? void 0 : _parts$find.value) ?? '0');
  const month = Number(((_parts$find2 = parts.find(p => p.type === 'month')) == null ? void 0 : _parts$find2.value) ?? '1') - 1;
  const day = Number(((_parts$find3 = parts.find(p => p.type === 'day')) == null ? void 0 : _parts$find3.value) ?? '1');
  return {
    year,
    month,
    day
  };
}
function differenceInCalendarMonths(later, earlier, timezone) {
  const l = getDatePartsInTimezone(later, timezone);
  const e = getDatePartsInTimezone(earlier, timezone);
  return (l.year - e.year) * 12 + (l.month - e.month);
}
function isDateOnOrAfter(date, reference, timezone) {
  if (!timezone) {
    return date >= reference;
  }
  const d = getDatePartsInTimezone(date, timezone);
  const r = getDatePartsInTimezone(reference, timezone);
  if (d.year !== r.year) {
    return d.year > r.year;
  }
  if (d.month !== r.month) {
    return d.month > r.month;
  }
  return d.day >= r.day;
}
export const getSubscriptionDisplayInfo = (subscription, options) => {
  const {
    amountPerBillingCycle,
    totalPayments,
    recurringStartDate
  } = subscription;
  if (!amountPerBillingCycle || totalPayments === null || totalPayments === undefined || !recurringStartDate) {
    return null;
  }
  const now = (options == null ? void 0 : options.now) ?? new Date();
  const startDate = new Date(recurringStartDate);
  const timezone = options == null ? void 0 : options.timezone;
  const isStarted = isDateOnOrAfter(now, startDate, timezone);
  let remainingPayments;
  if (!isStarted) {
    remainingPayments = totalPayments;
  } else {
    // Note: remaining payments calculation assumes MONTHLY frequency.
    // If new frequencies are added to FrequencyType, update this logic.
    const monthsElapsed = differenceInCalendarMonths(now, startDate, timezone);
    remainingPayments = Math.max(1, totalPayments - monthsElapsed);
  }
  const enrollmentFee = subscription.enrollmentFeeAmount;
  const hasEnrollmentFee = !!(enrollmentFee != null && enrollmentFee.value) && Number(enrollmentFee.value) > 0;
  return {
    amountPerCycle: amountPerBillingCycle,
    totalPayments,
    remainingPayments,
    isStarted,
    startDate,
    hasEnrollmentFee,
    enrollmentFee: hasEnrollmentFee ? enrollmentFee : undefined,
    frequency: subscription.frequency ?? FrequencyType.MONTHLY
  };
};
//# sourceMappingURL=subscription.js.map